import { Logging } from '#common/logging';
export const createMemKeyStore = () => {
    return new MemKeyStore();
};
export class MemKeyStore {
    storage = new Map();
    log = Logging.getLogger('InMemoryKeyStore');
    get(key) {
        return this.storage.get(key);
    }
    exists(key) {
        return this.storage.has(key);
    }
    put(key, value) {
        this.storage.set(key, value);
    }
    delete(key) {
        this.storage.delete(key);
    }
}
